import { jsx as _jsx } from "react/jsx-runtime";
import invariant from 'tiny-invariant';
import variants from './variants/index.js';
import { cn } from '../../utils/classnames.js';
function Icon({ name, className, ...other }) {
    invariant(name in variants, `Icon: Unknown icon name: '${name}'`);
    const Component = variants[name];
    return _jsx(Component, { className: cn('ui-flex-none', className), ...other });
}
export default Icon;
